export class EntityNotFoundError extends Error {
  public readonly entityId: string;

  constructor(entityId: string) {
    super(`Entity with id '${entityId}' not found.`);
    this.name = 'EntityNotFoundError';
    this.entityId = entityId;
  }
}
